module.exports = __webpack_public_path__ + "img/navcenter.95d4806d.png";